import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Cabserviceinpimprichichwad() {



  const cardData = {


  keyword: "Cab Service in Pimpri Chinchwad",

  headingDescription: "Trustline Cab provides reliable cab service in Pimpri Chinchwad with safe, comfortable, and affordable taxi solutions for local travel, airport transfers, corporate transportation, railway station pickups, family outings, and outstation journeys. Whether you need an instant local cab, a one-way taxi, or a full-day rental, our experienced chauffeurs ensure timely pickups and a hassle-free travel experience. Our fleet includes AC Sedans, SUVs, Innova Crysta, Ertiga, Tempo Travellers, and luxury vehicles to suit every travel requirement. With transparent pricing, easy online booking, doorstep pickup, and 24/7 customer support, Trustline Travels is the preferred choice for cab services in Pimpri Chinchwad.",

   topPlaces: [
   
    {
      title: "Mahabaleshwar",
      description: "Mahabaleshwar is a popular hill station offering breathtaking viewpoints, strawberry farms, Venna Lake, and cool weather, making it ideal for weekend trips."
    },
    {
      title: "Panchgani",
      description: "Panchgani is renowned for its beautiful valleys, Table Land, colonial charm, and pleasant climate, attracting families and nature lovers."
    },
     {
      title: "Lonavala",
      description: "Lonavala is a picturesque hill station near Pimpri Chinchwad, famous for its lush green valleys, waterfalls, Tiger Point, Bhushi Dam, and pleasant weather throughout the year."
    },
    {
      title: "Lavasa",
      description: "Lavasa is a planned hill city known for its colorful waterfront promenade, adventure activities, scenic landscapes, and peaceful surroundings."
    },
    {
      title: "Shirdi",
      description: "Shirdi is one of India's most famous pilgrimage destinations, attracting millions of devotees to the sacred Shri Sai Baba Temple every year."
    },
    {
      title: "Nashik",
      description: "Nashik is a renowned destination for vineyards, ancient temples, the Godavari River, and wine tourism, making it perfect for leisure and spiritual travel."
    },
    {
      title: "Mumbai",
      description: "Mumbai is India's financial capital, offering iconic attractions, business districts, shopping destinations, beaches, and world-class entertainment."
    },
    {
      title: "Alibaug",
      description: "Alibaug is a beautiful coastal town known for its clean beaches, sea forts, water sports, and relaxing seaside resorts."
    },
    {
      title: "Kolhapur",
      description: "Kolhapur is famous for the Mahalakshmi Temple, historic forts, delicious cuisine, and rich cultural heritage, making it a popular travel destination."
    },
    {
      title: "Goa",
      description: "Goa is India's favorite beach destination, offering golden beaches, vibrant nightlife, Portuguese architecture, water sports, and relaxing coastal experiences."
    }
  ],






"services": [
{
"name": "Cab Service in Pimpri Chinchwad",
"description": "Book reliable Cab Service in Pimpri Chinchwad for local travel, airport transfers, outstation trips, corporate travel, family tours, and one-way or round-trip taxi services. Choose from Sedan, Ertiga, Innova Crysta, and SUV cabs with experienced drivers, clean AC vehicles, doorstep pickup, transparent pricing, 24x7 support, and a safe, comfortable travel experience across Maharashtra."
},
{
"name": "Taxi Service in Pimpri Chinchwad",
"description": "Hire Taxi Service in Pimpri Chinchwad for daily travel, business meetings, airport transfers, railway station pickup, hotel transfers, and long-distance journeys. Enjoy punctual service, professional chauffeurs, sanitized vehicles, affordable fares, and hassle-free online taxi booking with instant confirmation."
},
{
"name": "Best Cab Service in Pimpri Chinchwad",
"description": "Choose the Best Cab Service in Pimpri Chinchwad offering premium vehicles, verified drivers, affordable rates, flexible booking options, and reliable transportation for local sightseeing, airport transfers, corporate travel, family vacations, and outstation tours with complete comfort and safety."
},
{
"name": "Online Cab Booking Pimpri Chinchwad",
"description": "Book online cab booking in Pimpri Chinchwad with instant confirmation, transparent pricing, multiple vehicle choices including Sedan, Ertiga, Innova Crysta, and SUVs, along with 24x7 customer support for local and outstation travel."
},
{
"name": "Outstation Cab Service Pimpri Chinchwad",
"description": "Book Outstation Cab Service Pimpri Chinchwad for comfortable travel to Mumbai, Nashik, Shirdi, Lonavala, Mahabaleshwar, Goa, Kolhapur, and other destinations with experienced drivers, well-maintained AC cars, and affordable one-way or round-trip packages."
},
{
"name": "One Way Cab Pimpri Chinchwad",
"description": "Choose One Way Cab Pimpri Chinchwad for affordable single-trip travel without paying return charges. Enjoy clean vehicles, punctual pickups, professional drivers, and convenient travel for airport transfers, business trips, and outstation journeys."
},
{
"name": "Airport Cab Service Pimpri Chinchwad",
"description": "Book Airport Cab Service Pimpri Chinchwad for reliable pickup and drop to Pune Airport, Mumbai Airport, and nearby airports with professional chauffeurs, spacious luggage capacity, and timely transfers available 24x7."
},
{
"name": "Cab Booking Pimpri Chinchwad",
"description": "Reserve Cab Booking Pimpri Chinchwad with easy online booking, instant confirmation, transparent fares, and a fleet of Sedan, Ertiga, Innova Crysta, and SUV vehicles for local and outstation travel."
},
{
"name": "Taxi Booking Pimpri Chinchwad",
"description": "Book Taxi Booking Pimpri Chinchwad for safe and comfortable transportation with experienced drivers, clean vehicles, affordable pricing, and reliable taxi services for personal, family, and business travel."
},
{
"name": "Cab Service in Pimpri",
"description": "Reliable Cab Service in Pimpri for local rides, airport transfers, railway station pickups, corporate travel, and outstation trips with well-maintained AC vehicles, courteous drivers, and affordable taxi fares."
},
{
"name": "Cab Service in Chinchwad",
"description": "Book Cab Service in Chinchwad for city travel, business transportation, airport pickup and drop, family outings, and long-distance taxi services with professional drivers and transparent pricing."
},
{
"name": "Cab Service in PCMC",
"description": "Choose Cab Service in PCMC for reliable local and outstation taxi services with Sedan, Ertiga, Innova Crysta, and SUV vehicles available for airport transfers, corporate travel, and family trips."
},
{
"name": "Taxi Service in PCMC",
"description": "Hire Taxi Service in PCMC for comfortable city rides, airport transfers, railway station pickup, business travel, and weekend tours with clean AC vehicles and experienced chauffeurs."
},
{
"name": "Cab Service in Akurdi",
"description": "Book Cab Service in Akurdi for local transportation, Pune Airport transfers, Mumbai Airport trips, corporate travel, and outstation journeys with safe, reliable, and affordable taxi services."
},
{
"name": "Cab Service in Nigdi",
"description": "Reliable Cab Service in Nigdi offering local taxi, airport cab, one-way travel, round-trip bookings, and chauffeur-driven vehicles for business, leisure, and family transportation."
},
{
"name": "Cab Service in Ravet",
"description": "Hire Cab Service in Ravet for local rides, airport pickup, Mumbai travel, and outstation cab booking with experienced drivers, clean vehicles, and competitive pricing."
},
{
"name": "Cab Service in Wakad",
"description": "Book Cab Service in Wakad for airport transfers, corporate travel, outstation tours, local sightseeing, and one-way taxi services with premium AC vehicles and professional chauffeurs."
},
{
"name": "Cab Service in Hinjewadi",
"description": "Choose Cab Service in Hinjewadi for IT professionals, corporate travel, airport transfers, and long-distance taxi services with reliable pickup, comfortable vehicles, and affordable fares."
},
{
"name": "Cab Service in Pimple Saudagar",
"description": "Book Cab Service in Pimple Saudagar for local travel, airport cabs, Mumbai transfers, and outstation journeys with well-maintained cars, experienced drivers, and transparent pricing."
},
{
"name": "Cab Service in Pimple Gurav",
"description": "Reliable Cab Service in Pimple Gurav for local taxi booking, airport transportation, family travel, and business trips with comfortable AC vehicles and 24x7 service."
},
{
"name": "Cab Service in Bhosari",
"description": "Hire Cab Service in Bhosari for airport pickup, railway station transfers, industrial visits, local travel, and outstation taxi services with professional chauffeurs and affordable rates."
},
{
"name": "Cab Service in Moshi",
"description": "Book Cab Service in Moshi for local rides, airport cabs, corporate transportation, family trips, and outstation travel with reliable drivers and clean AC cars."
},
{
"name": "Cab Service in Chikhali",
"description": "Choose Cab Service in Chikhali for local transportation, airport transfers, Mumbai trips, and outstation travel with safe, affordable, and chauffeur-driven taxi services."
},
{
"name": "Cab Service in Talawade",
"description": "Book Cab Service in Talawade for business travel, local rides, airport pickup and drop, and outstation taxi services with premium vehicles and experienced drivers."
},
{
"name": "Cab Service in Punawale",
"description": "Reliable Cab Service in Punawale for local travel, airport transfers, family outings, and long-distance journeys with transparent pricing and professional chauffeurs."
},
{
"name": "Cab Service in Thergaon",
"description": "Hire Cab Service in Thergaon for local taxi booking, airport transfers, business travel, and outstation tours with clean vehicles, experienced drivers, and comfortable rides."
},
{
"name": "Cab Service in Dange Chowk",
"description": "Book Cab Service in Dange Chowk for airport pickups, local city travel, Mumbai transfers, and outstation taxi services with reliable drivers and affordable fares."
},
{
"name": "Cab Service in Kalewadi",
"description": "Choose Cab Service in Kalewadi for local transportation, family trips, airport travel, and outstation journeys with comfortable AC vehicles and professional drivers."
},
{
"name": "Cab Service in Spine Road",
"description": "Book Cab Service in Spine Road for city rides, airport transfers, railway station pickup, and outstation travel with Sedan, Ertiga, Innova Crysta, and SUV vehicles."
},
{
"name": "Pimpri Chinchwad to Mumbai Airport Cab",
"description": "Book Pimpri Chinchwad to Mumbai Airport Cab for comfortable airport transfers with professional chauffeurs, punctual pickup, spacious luggage capacity, one-way and round-trip options, and affordable fares."
},
{
"name": "Mumbai Airport to Pimpri Chinchwad Cab",
"description": "Hire Mumbai Airport to Pimpri Chinchwad Cab for reliable airport pickup with flight tracking, experienced drivers, clean AC vehicles, doorstep drop, and 24x7 availability."
},
{
"name": "Mumbai Airport Taxi Service",
"description": "Book Mumbai Airport Taxi Service for airport pickup and drop with verified drivers, comfortable vehicles, transparent pricing, and dependable transportation for business and family travel."
},
{
"name": "Mumbai Airport Drop Cab",
"description": "Reserve Mumbai Airport Drop Cab for timely airport drop services with professional drivers, comfortable AC cars, online booking, and affordable one-way transportation."
},
{
"name": "Mumbai Airport Pickup Cab",
"description": "Book Mumbai Airport Pickup Cab with flight monitoring, meet-and-greet service, spacious vehicles, experienced chauffeurs, and reliable transfers to Pune, Pimpri Chinchwad, and nearby locations."
},
{
"name": "One Way Mumbai Airport Cab",
"description": "Choose One Way Mumbai Airport Cab for budget-friendly airport transfers without return charges, offering clean vehicles, professional drivers, instant booking, and comfortable long-distance travel."
}
],

"tableData": [
["Cab Service in Pimpri Chinchwad", "Taxi Service in Pimpri Chinchwad"],
["Best Cab Service in Pimpri Chinchwad", "Online Cab Booking Pimpri Chinchwad"],
["Outstation Cab Service Pimpri Chinchwad", "One Way Cab Pimpri Chinchwad"],
["Airport Cab Service Pimpri Chinchwad", "Cab Booking Pimpri Chinchwad"],
["Taxi Booking Pimpri Chinchwad", "Cab Service in Pimpri"],
["Cab Service in Chinchwad", "Cab Service in PCMC"],
["Taxi Service in PCMC", "Cab Service in Akurdi"],
["Cab Service in Nigdi", "Cab Service in Ravet"],
["Cab Service in Wakad", "Cab Service in Hinjewadi"],
["Cab Service in Pimple Saudagar", "Cab Service in Pimple Gurav"],
["Cab Service in Bhosari", "Cab Service in Moshi"],
["Cab Service in Chikhali", "Cab Service in Talawade"],
["Cab Service in Punawale", "Cab Service in Thergaon"],
["Cab Service in Dange Chowk", "Cab Service in Kalewadi"],
["Cab Service in Spine Road", "Pimpri Chinchwad to Mumbai Airport Cab"],
["Mumbai Airport to Pimpri Chinchwad Cab", "Mumbai Airport Taxi Service"],
["Mumbai Airport Drop Cab", "Mumbai Airport Pickup Cab"],
["One Way Mumbai Airport Cab", "Airport Cab Service Pimpri Chinchwad"]
],





whychoose: [
  {
    WhyChooseheading: "Reliable Cab Service in Pimpri Chinchwad",
    WhyChoosedescription: "Trustline Cab offers dependable cab services in Pimpri Chinchwad for local travel, airport transfers, corporate bookings, and outstation trips."
  },
  {
    WhyChooseheading: "24/7 Doorstep Pickup & Drop",
    WhyChoosedescription: "Enjoy convenient pickup and drop services from Pimpri, Chinchwad, Akurdi, Nigdi, Ravet, and nearby locations at any time."
  },
  {
    WhyChooseheading: "Professional & Verified Drivers",
    WhyChoosedescription: "Our trained chauffeurs ensure safe driving, courteous service, and a comfortable travel experience for every journey."
  },
  {
    WhyChooseheading: "Affordable Pricing with Complete Transparency",
    WhyChoosedescription: "Travel with confidence through competitive cab fares, upfront pricing, and no hidden charges."
  },
  {
    WhyChooseheading: "Wide Range of Vehicles",
    WhyChoosedescription: "Choose from Sedan, Ertiga, Innova, Innova Crysta, SUVs, and Tempo Travellers for individual, family, or group travel."
  },
  {
    WhyChooseheading: "Local & Outstation Cab Services",
    WhyChoosedescription: "Book cabs for city travel, airport transfers, corporate travel, sightseeing, and outstation destinations across Maharashtra and beyond."
  },
  {
    WhyChooseheading: "Easy Online Booking",
    WhyChoosedescription: "Reserve your cab quickly with instant fare quotations, fast confirmation, and dedicated customer support."
  },
  {
    WhyChooseheading: "Trusted by Regular Travelers",
    WhyChoosedescription: "Customers choose Trustline Travels for punctual service, clean vehicles, and reliable transportation throughout Pimpri Chinchwad."
  }
]

};

const faqData = [
  {
    question: "Does Trustline Cab provide cab service in Pimpri Chinchwad?",
    answer: "Yes, Trustline Cab offers reliable cab services in Pimpri Chinchwad for local travel, airport transfers, outstation trips, and corporate bookings."
  },
  {
    question: "Can I book a local cab in Pimpri Chinchwad?",
    answer: "Yes, we provide local cab services for shopping, office travel, business meetings, and city transportation."
  },
  {
    question: "Which vehicles are available for booking?",
    answer: "We offer Sedan cars, Ertiga, Innova, Innova Crysta, SUVs, and Tempo Travellers for different travel requirements."
  },
  {
    question: "Do you provide Pune and Mumbai Airport cab services?",
    answer: "Yes, we offer reliable airport pickup and drop services to both Pune Airport and Mumbai Airport."
  },
  {
    question: "Can I book a one-way outstation cab?",
    answer: "Yes, one-way and round-trip outstation cab services are available from Pimpri Chinchwad to multiple destinations."
  },
  {
    question: "Are toll and parking charges included in the fare?",
    answer: "Toll charges, parking fees, and applicable taxes are generally charged separately unless specifically mentioned during booking."
  },
  {
    question: "Is cab service available 24 hours?",
    answer: "Yes, Trustline Cab provides 24/7 cab services for local, airport, and outstation travel."
  },
  {
    question: "Do you provide corporate cab services?",
    answer: "Yes, we offer cab solutions for corporate employees, office travel, business meetings, and company transportation requirements."
  },
  {
    question: "Can I schedule my cab in advance?",
    answer: "Yes, advance booking is recommended to ensure vehicle availability and timely pickup."
  },
  {
    question: "How can I book a cab service in Pimpri Chinchwad with Trustline Travels?",
    answer: "Simply share your pickup location, destination, travel date, and preferred vehicle to receive an instant quotation and booking confirmation."
  }
];

const testimonials = [
  {
    id: 1,
    name: "Mr. Saurabh Patil",
    feedback: "Trustline Travels has become my preferred cab service in Pimpri Chinchwad. The booking process was simple, the driver arrived on time, and the journey was comfortable from start to finish.",
    rating: 5
  },
  {
    id: 2,
    name: "Mrs. Manisha Kulkarni",
    feedback: "We booked a cab for an outstation trip from Pimpri Chinchwad, and the service was outstanding. The vehicle was clean, the driver was professional, and the entire travel experience was smooth and enjoyable.",
    rating: 5
  }
];







  const Images = [
    { place: "/images/keyword/29.jpeg", text: "Pune to Mumbai Cabs", link: "Pune-to-Mumbai-Cabs" },
    { place: "/images/keyword/30.jpg", text: "Pune to Mumbai Airport Cab", link: "Pune-to-Mumbai-Airport-Cab" },
    { place: "/images/keyword/31.jpg", text: "Pune to Mumbai International Airport Cab", link: "Pune-to-Mumbai-International-Airport-Cab" },
    { place: "/images/keyword/32.jpg", text: "Pune to Mumbai One Way Cab", link: "Pune-to-Mumbai-One-Way-Cab" },
    { place: "/images/keyword/33.jpg", text: "Pune Mumbai Car Hire", link: "Pune-Mumbai-Car-Hire" },
    { place: "/images/keyword/34.jpg", text: "Pune to Mumbai Taxi Fare", link: "Pune-to-Mumbai-Taxi-Fare" },
    { place: "/images/keyword/35.jpg", text: "Pune to Mumbai Online Cab Booking", link: "Pune-to-Mumbai-Online-Cab-Booking" },
    { place: "/images/keyword/36.jpg", text: "Pimpri Chinchwad to Mumbai Cab", link: "Pimpri-Chinchwad-to-Mumbai-Cab" },
    { place: "/images/keyword/37.jpg", text: "Baner to Mumbai Cabs", link: "Baner-to-Mumbai-Cabs" },
    { place: "/images/keyword/38.jpg", text: "Hinjewadi to Mumbai Cabs", link: "Hinjewadi-to-Mumbai-Cabs" },
    { place: "/images/keyword/39.jpg", text: "Pimple Saudagar to Mumbai Cab Service", link: "Pimple-Saudagar-to-Mumbai-Cab-Service" },
    { place: "/images/keyword/40.jpg", text: "Wakad to Mumbai Cabs", link: "Wakad-to-Mumbai-Cabs" },
    { place: "/images/keyword/41.jpg", text: "Hadapsar to Mumbai Cabs", link: "Hadapsar-to-Mumbai-Cabs" },
    { place: "/images/keyword/42.jpg", text: "Kalyani Nagar to Mumbai Taxi", link: "Kalyani-Nagar-to-Mumbai-Taxi" },
    { place: "/images/keyword/43.jpg", text: "Koregaon Park to Mumbai Cabs", link: "Koregaon-Park-to-Mumbai-Cabs" },
    { place: "/images/keyword/44.jpg", text: "Kothrud to Mumbai Cabs", link: "Kothrud-to-Mumbai-Cabs" },
    { place: "/images/keyword/45.jpg", text: "Kharadi to Mumbai Cabs", link: "Kharadi-to-Mumbai-Cabs" },
    { place: "/images/keyword/46.jpg", text: "Shivajinagar to Mumbai Cabs", link: "Shivajinagar-to-Mumbai-Cabs" },
    { place: "/images/keyword/47.jpg", text: "Pune to Mumbai Ertiga Cab", link: "Pune-to-Mumbai-Ertiga-Cab" },
    { place: "/images/keyword/48.jpg", text: "Pune to Mumbai Innova Crysta Cabs", link: "Pune-to-Mumbai-Innova-Crysta-Cabs" },
    { place: "/images/keyword/49.jpg", text: "Pune to Mumbai Sedan Cab", link: "Pune-to-Mumbai-Sedan-Cab" },
    { place: "/images/keyword/50.jpg", text: "Kondhwa to Mumbai Cabs", link: "Kondhwa-to-Mumbai-Cabs" },
    { place: "/images/keyword/51.jpg", text: "Viman Nagar to Mumbai Cabs", link: "Viman-Nagar-to-Mumbai-Cabs" },
    { place: "/images/keyword/52.jpg", text: "Katraj to Mumbai Cab Service", link: "Katraj-to-Mumbai-Cab-Service" },
    { place: "/images/keyword/53.jpg", text: "Pune Station to Mumbai Cabs Service", link: "Pune-Station-to-Mumbai-Cabs-Service" },
    { place: "/images/keyword/54.jpg", text: "Boat Club Road to Mumbai Cabs", link: "Boat-Club-Road-to-Mumbai-Cabs" },
    { place: "/images/keyword/55.jpg", text: "Vishrantwadi to Mumbai Cabs", link: "Vishrantwadi-to-Mumbai-Cabs" },
];









const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Cab Service in Pimpri Chinchwad",
  "image": "https://www.trustlinetravels.com/assets/images/cab-service-in-pimpri-chinchwad.webp",
  "description": "Book cab service in Pimpri Chinchwad for safe, comfortable, and affordable local and outstation travel. Trustline Travels offers airport cabs, one-way taxis, outstation cab services, and premium cab options including Sedan, Ertiga, SUV, Innova, and Innova Crysta available 24x7.",
  "brand": {
    "@type": "Brand",
    "name": "Trustline Travels"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "7489"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "Starting From ₹12/Km",
    "availability": "https://schema.org/InStock",
    "url": "https://www.trustlinetravels.com/cab-service-in-pimpri-chinchwad"
  }
};





  return (
    <div>

<Helmet>
  <title>Cab Service in Pimpri Chinchwad | Taxi Booking | +91 8087080034</title>

  <meta
    name="description"
    content="Book the best cab service in Pimpri Chinchwad with Trustline Travels. Get local taxi, airport cab, one-way cab, and outstation cab services with Sedan, Ertiga, SUV, Innova, and Innova Crysta options available 24x7."
  />

  <meta
    name="keywords"
    content="Cab Service in Pimpri Chinchwad, Taxi Service in Pimpri Chinchwad, Best Cab Service in Pimpri Chinchwad, Online Cab Booking Pimpri Chinchwad, Outstation Cab Service Pimpri Chinchwad, One Way Cab Pimpri Chinchwad, Airport Cab Service Pimpri Chinchwad, Cab Booking Pimpri Chinchwad, Taxi Booking Pimpri Chinchwad, Cab Service Pimpri Chinchwad Pune, Pimpri Chinchwad taxi service, PCMC cab booking, PCMC airport taxi, Pimpri Chinchwad outstation cab"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>

      <div
  className="wt-bnr-inr site-bg-dark twm-primary-overlay-wrap"
  style={{
    backgroundImage:
      "linear-gradient(90deg, rgba(0,0,0,0.75) 0%, rgba(0,0,0,0.75) 50%, rgba(0,0,0,0.75) 100%), url('/images/banner-10.jpg')",
    backgroundSize: "cover",
    backgroundPosition: "center",
  }}
>
        <div className="twm-primary-overlay"></div>

        <div className="container">
          <div className="wt-bnr-inr-entry">
            <div className="banner-title-ouer">
              <div className="banner-title-name">
                <h2 className="wt-title">{cardData.keyword}</h2>
              </div>
            </div>
          </div>
        </div>
      </div>
















      <section>
        <div className="container-fluid pdfing" >
          <div className="row container-fluid pdfing">
            <div className="col-12 col-md-7 bg-foootr p-0">
              <img src='/images/keyword/58.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >Trustline Cab: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                {/* <p className="sectionLead">{cardData.top}</p> */}

                <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard borderr" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>

                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>


              {/* <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                  
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div> */}


              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div className="service-card" key={index}>
                    <div className="service-content">
                      <h4>{service.name}</h4>
                      <span className="line"></span>
                      <p>{service.description}</p>
                    </div>

                    <div className="service-icon">
                      <i className="fas fa-arrow-right"></i>
                    </div>
                  </div>
                ))}
              </div>

              <div className="keyword-grid">
                {cardData.tableData.flat().map((keyword, index) => (
                  <div key={index} className="keyword-item">
                    <span className="keyword-bullet">-</span>
                    {keyword}
                  </div>
                ))}
              </div>
              {/* <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable /> */}

              {/* <div id="why-choose-section" className="why-choose-section">


                
                <h2 className="section-title text-white">
                  Why Choose <span>Trustline Cab</span>
                </h2>

               
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div> */}


              <div id="why-choose-section" className="why-choose-section">

                <h2 className="section-title text-white">
                  Why Choose <span>Trustline Cab</span>
                </h2>

                <div className="bento-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div className="bento-card" key={index}>

                      <div className="bento-number">
                        {String(index + 1).padStart(2, "0")}
                      </div>

                      <h4>{item.WhyChooseheading}</h4>

                      <p>{item.WhyChoosedescription}</p>

                    </div>
                  ))}
                </div>

              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Trustline Cab</h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title=""
                          subtitle=""
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase keyword={cardData.keyword} />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="fas fa-phone-alt"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+918087080034 " className="pc-call">+91 8087080034 </a>
                      <a href="tel:+919421185217" className="pc-call">+91 9421185217</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/918087080034 "
                        target="_blank"
                        rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp"></i> WhatsApp
                      </a>
                      <a href="tel:+918087080034 " className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="fa-solid fa-envelope"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@trustlinetravels.com" className="pc-email">
                      booking@trustlinetravels.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="fa-solid fa-location-dot"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Trustline Travels</strong><br />
                      Office  No 3 ,Shive Pride, Lane No 14,
                      Swami Samarth Nagar, Sathe Nagar,
                      Lohegaon, Pune, Maharashtra-411047.



                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Cabserviceinpimprichichwad;